export const common: object = {
  common: {
    cancel: 'Abbrechen',
    delete: 'Löschen',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    here: 'hier',
    back: 'Zurück',
    submit: 'Abschicken',
    continue: 'Fortfahren',
    save: 'Speichern',
    done: 'Fertig',
    home: 'Start',
    dot: '.',
    colon: ':',
    braces: '({{parameter}})',
    braceOpen: '(',
    braceClose: ')',
    more: 'Mehr',
    less: 'Weniger',
    optional: '(Optional)',
    sapAppCenter: 'SAP App Center',
    parameter: '{{parameter}}',
  },
  error: {
    somethingWrong: 'Something went wrong'
  },
  pageMetaResolver: {
    noProductsFound: 'Keine Lösungen gefunden für',
    resultsFor: '{{count}} Ergebnisse für',
    facetResult: '{{count}} Ergebnisse',
    category: {
      title: '{{count}} Ergebnisse für {{query}}',
      title_plural: '{{count}} Ergebnisse für {{query}}',
    },
    checkout: {
      title: 'Checkout {{count}} item',
      title_plural: 'Checkout {{count}} items',
    },
    search: {
      title: '{{count}} Ergebnisse für "{{query}}"',
      title_plural: '{{count}} Ergebnisse für "{{query}}"',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
    no_product: {
      title: 'Keine Produkte gefunden für \"{{query}}\"',
    },
    productUnavailable: 'Die gewählte Lösung ist nicht verfügbar',
  },
  spinner: {
    loading: 'Lädt...',
  },
  navigation: {
    shopAll: 'Shop all {{ navNode}} >',
  },
  searchBox: {
    placeholder: 'Suchen...',
    help: {
      insufficientChars: 'Please type more characters',
      noMatch: 'Wir konnten keine Ergebnisse finden',
      exactMatch: '{{ term }}',
      empty: 'Ask us anything',
    },
  },
  sorting: {
    date: 'Date',
    orderNumber: 'Order Number',
  },
  httpHandlers: {
    badGateway: 'A server error occurred. Please try again later.',
    badRequestPleaseLoginAgain: '{{ errorMessage }}. Please login again.',
    badRequestOldPasswordIncorrect: 'Old password incorrect.',
    conflict: 'Already exists',
    forbidden: 'You are not authorized to perform this action.',
    gatewayTimeout: 'The server did not respond, please try again later.',
    internalServerError:
      'An internal Server Error occurred. Please try again later.',
    unknownError: 'An unknown error occurred',
    validationErrors: {
      missing: {
        card_cardType:
          'The selected credit card is not supported. Please select another.',
        card_accountNumber: 'The credit card number entered is not valid.',
        card_cvNumber: 'The security code entered is not valid.',
        card_expirationMonth:
          'The credit card expiration date entered is not valid.',
        card_expirationYear:
          'The credit card expiration date entered is not valid.',
        billTo_firstName: 'The first name entered is not valid.',
        billTo_lastName: 'The last name entered is not valid.',
        billTo_street1: 'The address entered is not valid.',
        billTo_street2: 'The address entered is not valid.',
        billTo_city: 'The city entered is not valid for this credit card.',
        billTo_state:
          'The state/province entered is not valid for this credit card.',
        billTo_country:
          'The country entered is not valid for this credit card.',
        billTo_postalCode:
          'The zip/postal code is not valid for this credit card.',
        country: {
          isocode: 'Missing country',
        },
      },
      invalid: {
        card_expirationMonth:
          'The credit card expiration date entered is not valid.',
      },
    },
    cartNotFound: 'Cart not found.',
  },
  miniCart: {
    item: '{{count}} item currently in your cart',
    item_plural: '{{count}} items currently in your cart',
  },
  miniLogin: {
    userGreeting: 'Hi, {{name}}',
    signInRegister: 'Anmelden / Registrieren',
  },
};
